import {isHTMLElement} from './utils';

export const nodeAddedMap: Map<string, (target: HTMLElement) => void> =
  new Map();
export const attributeFilter: Set<string> = new Set();

// watch for added nodes and attach
const mutationObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!isHTMLElement(node)) {
        continue;
      }
      for (const [selector, handler] of nodeAddedMap) {
        if (node.matches(selector)) {
          handler(node);
        }
      }
    }
    if (mutation.attributeName) {
      for (const [selector, handler] of nodeAddedMap) {
        if (
          `[${mutation.attributeName}]` === selector &&
          isHTMLElement(mutation.target)
        ) {
          handler(mutation.target);
        }
      }
    }
  }
});

export function listen() {
  // attach to existing DOM nodes
  for (const [selector, handler] of nodeAddedMap) {
    const nodes = document.querySelectorAll(selector);
    for (const node of nodes) {
      if (isHTMLElement(node)) {
        handler(node);
      }
    }
  }

  mutationObserver.observe(document.body, {
    subtree: true,
    childList: true,
    attributeFilter: [...attributeFilter],
  });
}
